"use client";

import { cn } from "@/utils";

export function ChartTable({
  values,
  className,
}: {
  values: Record<string, string>;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-xl border border-white/[0.06] bg-surface-300/20",
        className,
      )}
    >
      {Object.entries(values).map(([key, val], index) => (
        <div
          key={key}
          className={cn(
            "grid grid-cols-1 gap-1 px-4 py-3 sm:grid-cols-2 sm:gap-4",
            index > 0 && "border-t border-white/[0.05]",
          )}
        >
          <span className="text-sm text-muted">{key}</span>
          <span className="text-sm font-medium text-white">{val}</span>
        </div>
      ))}
    </div>
  );
}
